import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../styles/TicketsHome.module.scss';
import useAlert from '../../hooks/useAlert';
import { GetGenioLiteOptions, UserFeedbackTicketSubmit, getCheckDetails, CreateTicket } from '../../api';
import { CheckingValidComment, clickTracker } from '../../lib/common';
import { onClickEvent } from '../../lib/gaAnalytics';
import { handleSetBannerTypeData } from '../../reducersAndActions/actions/appStateActions';
import DynamicSearchBar from '../DynamicSearchBar';
import { GenioWithAuth, usePopup } from '../../hooks';
import { useAppState } from '../../contexts/appState';
import { CommonPopup, OthersPopup } from '../Popups';
import QuickCheckPopup from '../Popups/QuickCheckPopup/QuickCheckPopup';
import RaiseTicketPopup from '../Popups/RaiseTicketPopup/RaiseTicketPopup';

function GenioOptions() {
  const [appState] = useAppState();
  const { popupObj } = appState;
  const navigate = useNavigate();
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const selectedBusinessData = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const [optionsData, setOptionsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [issueComment, setIssueComment] = useState('');
  const [setAlert] = useAlert();
  const [setPopup] = usePopup();
  const [othersData, setOthersData] = useState([]);
  const [showFeedbackOptionModal, setShowFeedbackOptionModal] = useState(false);
  const [checkDetails, setCheckDetails] = useState({});
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const queryParams = new URLSearchParams(window.location.search);

  const [, appDispatch] = useAppState();
  sessionStorage.removeItem('feedback');
  sessionStorage.removeItem('faqsFeedback');
  sessionStorage.removeItem('bannerType');
  sessionStorage.removeItem('activeBannerFlag');

  const getOptions = async () => {
    try {
      setLoading(true);
      const params = {
        parentId: selectedBusinessData?.parentId || '',
        city: selectedBusinessData?.city || '',
        department: profile?.department || '',
      };
      const res = await GetGenioLiteOptions(params);
      if (res.errorCode === 0) {
        setOptionsData(res.result || []);
        sessionStorage.setItem('contractType', res?.result?.contractType || '');
      }
      setLoading(false);
    } catch (e) {
      console.log('Error: ', e);
    }
  };

  useEffect(() => {
    if (profile && profile?.empCode) {
      getOptions();
    }
  }, []);

  useEffect(() => {
    const handleGetDetail = async () => {
      try {
        const paramsData = {
          parentid: selectedBusinessData?.parentId || '',
          data_city: selectedBusinessData?.city || '',
        };
        const res = await getCheckDetails(paramsData);
        if (res.errorCode === 0) {
          setCheckDetails(res.result || {});
        }
      } catch (e) {
        console.log(e);
      }
    };
    if (selectedBusinessData?.parentId && showFeedbackOptionModal) {
      handleGetDetail();
    }
  }, [showFeedbackOptionModal, selectedBusinessData?.parentId]);

  const handleOptionClick = async (option, questionId = '') => {
    localStorage.setItem('searchQid', questionId);
    await clickTracker(`issue_${option?.trackerID}`, 'geniocs_faq_issue');
    onClickEvent(`GENIO-Main Page-FAQ Name`, option?.key || '', option?.key || '');
    if (option?.key === 'edit_my_business') {
      navigate('/genio/edit_business');
    } else if (option?.key === 'banner_jdrr') {
      handleSetBannerTypeData(appDispatch, {
        bannerTypeData: {},
      });
      navigate('/genio/banner');
    } else if (option?.key === 'ecs') {
      navigate('/genio/ecs');
    } else if (option?.key === 'contract_information') {
      navigate('/genio/contract');
    } else if (option?.key === 'leads') {
      navigate('/genio/leads');
    } else if (option.key === 'payments') {
      navigate('/genio/payments');
    } else if (option?.type === 'popup') {
      setPopup({
        open: true,
        popupType: 'postIssue',
        heading: 'Report an Issue',
        placeholder: 'Please write your query here, our support team will act on it within 24-48 hours',
      });
    } else if (option?.type === 'redirect') {
      window.location = option.url;
    } else if (option?.type === 'others') {
      setOthersData(option.data);
      setPopup({
        open: true,
        popupType: 'OthersPopup',
        heading: 'Others',
      });
    } else if (option?.type === 'create') {
      if (selectedBusinessData?.parentId && selectedBusinessData?.city) {
        navigate(`/genio/category_create_ticket`);
      }
    } else {
      navigate(`/genio/faq/${option.key}`);
    }
  };
  const handleClosePopup = () => {
    onClickEvent(`GenioMain-User`, 'Cancel', 'Cancel');
    document.body.style.overflow = 'unset';
    setIssueComment('');
    setPopup({});
  };

  const handleOthersClose = () => {
    document.body.style.overflow = 'unset';
    setPopup({});
  };

  const handleGrievanceSubmit = async () => {
    onClickEvent(`GenioMain-User`, 'Submit', 'Submit');
    handleClosePopup();
    try {
      if (CheckingValidComment(issueComment)) {
        const res = await UserFeedbackTicketSubmit(
          profile?.full_name || '',
          profile?.mobile || '',
          profile?.empEmail || '',
          profile?.city || '',
          'Other Issues',
          'User_NewCS',
          issueComment.trim(),
        );
        if (res.errorCode === 0) {
          setAlert({
            message: res.message || 'Success',
            status: true,
          });
        } else {
          setAlert({
            message: res?.message || 'Error',
            status: false,
          });
        }
      }
    } catch (e) {
      console.log('Error: ', e);
    }
  };
  const handleSubmit = async () => {
    try {
      if (selectedBusinessData?.mobile) {
        const paramsObj = {
          vertical: 'content',
          category: 'onboarding',
          ticket_creator: 'BUSINESS',
          nm: selectedBusinessData?.contractPersonName || selectedBusinessGenio?.companyName || '',
          created_by: profile?.mobile || '',
          mob: selectedBusinessData?.mobile || '',
          issue_type: checkDetails?.issueSubIssueDetails?.issue_type || '',
          issue_sub_type: selectedOption || '',
          issue_comment: '',
          document: [],
          oid: '',
          orderid: '',
          city: selectedBusinessData?.city || '',
          docid: selectedBusinessData?.docId || '',
          src: 'sales-genio',
          src_typ: selectedBusinessData?.concern === 'client' ? 'client' : 'internal',
          src_nm: profile?.full_name || '',
          src_mob: profile?.mobile || '',
          projectId: '',
          parentId: selectedBusinessData?.parentId || '',
          compnm: selectedBusinessData?.companyName || '',
          bannerCta: queryParams?.get('bannerCta') || '',
          source: 'onboardingmodule_genioticket',
        };
        const res = await CreateTicket(paramsObj);
        if (res.errorCode === 0) {
          setAlert({
            message: res?.result?.msg || 'Success!',
            status: true,
          });
        } else {
          setAlert({
            message:
              (res?.message && typeof res?.message === 'string' && res?.message) ||
              (res?.result && res?.result?.msg) ||
              'Something Went Wrong!',
            status: false,
          });
        }
        navigate(-1);
      } else {
        setAlert({
          message: 'No Mobile number found in the contract. Validate with Database team.',
          status: false,
        });
      }
    } catch (err) {
      console.log('Error: ', err);
    }
  };

  return (
    <>
      <section className="cspage cstickets no-highlighting">
        <DynamicSearchBar handleOptionClick={handleOptionClick} contractType={optionsData?.contractType} page="genio" />
        <div className="cshotkeybox p-20 pb-10">
          {loading ? (
            <div className="loader-container">
              <div className="bt-spinner" />
            </div>
          ) : (
            <>
              <div className="landingbox_text pl-20 pr-20">
                <div className="font15 fw700 color111">
                  {optionsData &&
                  optionsData?.contractType &&
                  ['paid', 'expiredShort'].includes(optionsData?.contractType)
                    ? 'Tell us how we can help?'
                    : 'Oops! The business seems to be a non-paid business'}
                </div>
                {optionsData &&
                  optionsData?.contractType &&
                  ['paid', 'expiredShort'].includes(optionsData?.contractType) && (
                    <div className="font11 fw400 color777 mt-5">
                      Our crew of superheroes are standing by for service &amp; support!
                    </div>
                  )}
              </div>

              <ul className="hotkeybox_listgroup">
                {optionsData &&
                  optionsData?.options &&
                  optionsData?.options?.length > 0 &&
                  optionsData?.options.map((each, idx) => (
                    <li key={idx} className={`${styles.Contract__ListGroupItem} `}>
                      <div
                        tabIndex={0}
                        role="button"
                        onKeyDown={() => {}}
                        onClick={() => {
                          if (each?.key === 'Digital') {
                            setShowFeedbackOptionModal(true);
                          } else {
                            handleOptionClick(each);
                          }
                        }}
                        className={`${styles.Contract__ListGroupAnchor} whitefill_animate`}
                      >
                        <div className={`csicon hotkeybox_icon ${each.icon}`} />
                        <div className={`${styles.Contract__ListGroupText} pl-12 pr-20`}>
                          <div className={`${styles.Contract__ListGroupTitle}  font14 fw600 color111`}>
                            {each.title}
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>
            </>
          )}
        </div>
      </section>

      {popupObj?.popupType === 'postIssue' && (
        <CommonPopup
          comment={issueComment}
          setComment={setIssueComment}
          handleCommentSubmit={handleGrievanceSubmit}
          handleClosePopup={handleClosePopup}
        />
      )}

      {popupObj?.popupType === 'OthersPopup' && (
        <OthersPopup
          handleClosePopup={handleOthersClose}
          othersData={othersData}
          setAlert={setAlert}
          handleFaqRedirection={handleOptionClick}
        />
      )}
      {showFeedbackOptionModal && (
        <QuickCheckPopup
          showFeedbackOptionModal={showFeedbackOptionModal}
          setShowFeedbackOptionModal={setShowFeedbackOptionModal}
          checkDetails={checkDetails}
          setShowTicketModal={setShowTicketModal}
        />
      )}
      {showTicketModal && (
        <RaiseTicketPopup
          setShowTicketModal={setShowTicketModal}
          optionList={checkDetails?.issueSubIssueDetails?.disp_obj}
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
}

export default GenioWithAuth(GenioOptions);
